// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Hanken+Grotesk:ital,wght@0,100..900;1,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grigo-landing {
  color-scheme: light;
  --bg: #f2f5fb;
  --surface: #ffffff;
  --surface-2: #f0f4fa;
  --surface-3: #e4eaf4;
  --glass: rgba(255, 255, 255, 0.72);
  --glass-line: rgba(255, 255, 255, 0.9);
  --nav-bg: rgba(255, 255, 255, 0.88);
  --ink: #0f1a33;
  --ink-2: #37435f;
  --ink-3: #566380;
  --line: rgba(15, 26, 51, 0.1);
  --line-strong: #7a889f;
  --brand: #2b4a78;
  --brand-grad: linear-gradient(180deg, #3d64a3 0%, #27467a 100%);
  --on-brand: #ffffff;
  --focus: #2b4a78;
  --sage: #7c9790;
  --sage-soft: #e4eee9;
  --sage-ink: #3a6553;
  --sage-gfx: #5e8a75;
  --blue: #627ea3;
  --blue-soft: #e3ebf6;
  --blue-ink: #35588c;
  --blue-gfx: #4e6f9e;
  --amber: #e3a33e;
  --amber-soft: #fbebd0;
  --amber-ink: #8a5a0b;
  --amber-gfx: #b77a12;
  --tan-gfx: #8a6a3a;
  --err: #a32b2b;
  --err-soft: #f9e4e4;
  --ok: #2f6b4a;
  --ok-soft: #ddeee4;
  --warn: #8a5a0b;
  --warn-soft: #fbebd0;
  --aurora-a: #9cc4b3;
  --aurora-b: #8eace0;
  --aurora-c: #f4be6b;
  --aurora-o: 0.55;
  --sh-1: 0 1px 2px rgba(15, 26, 51, 0.05), 0 10px 28px -14px rgba(15, 26, 51, 0.16);
  --sh-2: 0 2px 4px rgba(15, 26, 51, 0.05), 0 28px 64px -28px rgba(15, 26, 51, 0.3);
  --sh-window: 0 50px 120px -40px rgba(32, 62, 120, 0.55), 0 10px 30px -10px rgba(15, 26, 51, 0.14);
  --btn-glow: 0 10px 24px -10px rgba(43, 74, 120, 0.75);
  --r-s: 8px;
  --r-m: 12px;
  --r-l: 20px;
  --r-xl: 28px;
  --font: 'Hanken Grotesk', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  --mono: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  min-height: 100vh;
  margin: 0;
  background: var(--bg);
  color: var(--ink);
  font-family: var(--font);
  font-size: 1.0625rem;
  line-height: 1.6;
  font-weight: 450;
  text-align: left;
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
}

.grigo-landing,
.grigo-landing *,
.grigo-landing *::before,
.grigo-landing *::after {
  box-sizing: border-box;
}

.grigo-landing,
.grigo-landing * {
  font-family: var(--font);
}

@media (prefers-color-scheme: dark) {
  .grigo-landing:not([data-theme='light']) {
    color-scheme: dark;
    --bg: #080f1e;
    --surface: #111b30;
    --surface-2: #17233c;
    --surface-3: #1f2e4b;
    --glass: rgba(20, 31, 54, 0.7);
    --glass-line: rgba(255, 255, 255, 0.1);
    --nav-bg: rgba(17, 27, 48, 0.86);
    --ink: #eef2f8;
    --ink-2: #c0cadc;
    --ink-3: #9aa7bf;
    --line: rgba(255, 255, 255, 0.11);
    --line-strong: #6b7b99;
    --brand: #8fb0e6;
    --brand-grad: linear-gradient(180deg, #a9c4f0 0%, #84a6de 100%);
    --on-brand: #0b1428;
    --focus: #8fb0e6;
    --sage-soft: #1b2f28;
    --sage-ink: #9cc7b2;
    --sage-gfx: #7fb39a;
    --blue-soft: #1b2a47;
    --blue-ink: #9db9e6;
    --blue-gfx: #7fa2db;
    --amber-soft: #3a2e14;
    --amber-ink: #f0bc62;
    --amber-gfx: #e3a63f;
    --tan-gfx: #c9a56a;
    --err: #f29b9b;
    --err-soft: #3c1f24;
    --ok: #8fd1ac;
    --ok-soft: #1a3226;
    --warn: #f0bc62;
    --warn-soft: #3a2e14;
    --aurora-a: #3e7a66;
    --aurora-b: #3c5fb0;
    --aurora-c: #b9791f;
    --aurora-o: 0.4;
    --sh-1: 0 1px 2px rgba(0, 0, 0, 0.3), 0 10px 28px -14px rgba(0, 0, 0, 0.6);
    --sh-2: 0 2px 4px rgba(0, 0, 0, 0.3), 0 28px 64px -28px rgba(0, 0, 0, 0.8);
    --sh-window: 0 50px 120px -40px rgba(60, 100, 200, 0.45), 0 10px 30px -10px rgba(0, 0, 0, 0.5);
    --btn-glow: 0 10px 28px -10px rgba(143, 176, 230, 0.55);
  }
}

.grigo-landing[data-theme='dark'] {
  color-scheme: dark;
  --bg: #080f1e;
  --surface: #111b30;
  --surface-2: #17233c;
  --surface-3: #1f2e4b;
  --glass: rgba(20, 31, 54, 0.7);
  --glass-line: rgba(255, 255, 255, 0.1);
  --nav-bg: rgba(17, 27, 48, 0.86);
  --ink: #eef2f8;
  --ink-2: #c0cadc;
  --ink-3: #9aa7bf;
  --line: rgba(255, 255, 255, 0.11);
  --line-strong: #6b7b99;
  --brand: #8fb0e6;
  --brand-grad: linear-gradient(180deg, #a9c4f0 0%, #84a6de 100%);
  --on-brand: #0b1428;
  --focus: #8fb0e6;
  --sage-soft: #1b2f28;
  --sage-ink: #9cc7b2;
  --sage-gfx: #7fb39a;
  --blue-soft: #1b2a47;
  --blue-ink: #9db9e6;
  --blue-gfx: #7fa2db;
  --amber-soft: #3a2e14;
  --amber-ink: #f0bc62;
  --amber-gfx: #e3a63f;
  --tan-gfx: #c9a56a;
  --err: #f29b9b;
  --err-soft: #3c1f24;
  --ok: #8fd1ac;
  --ok-soft: #1a3226;
  --warn: #f0bc62;
  --warn-soft: #3a2e14;
  --aurora-a: #3e7a66;
  --aurora-b: #3c5fb0;
  --aurora-c: #b9791f;
  --aurora-o: 0.4;
  --sh-1: 0 1px 2px rgba(0, 0, 0, 0.3), 0 10px 28px -14px rgba(0, 0, 0, 0.6);
  --sh-2: 0 2px 4px rgba(0, 0, 0, 0.3), 0 28px 64px -28px rgba(0, 0, 0, 0.8);
  --sh-window: 0 50px 120px -40px rgba(60, 100, 200, 0.45), 0 10px 30px -10px rgba(0, 0, 0, 0.5);
  --btn-glow: 0 10px 28px -10px rgba(143, 176, 230, 0.55);
}

.grigo-landing img,
.grigo-landing svg {
  display: block;
  max-width: 100%;
}

.grigo-landing h1,
.grigo-landing h2,
.grigo-landing h3,
.grigo-landing h4,
.grigo-landing p,
.grigo-landing ul,
.grigo-landing ol,
.grigo-landing dl,
.grigo-landing dd,
.grigo-landing figure {
  margin: 0;
}

.grigo-landing ul,
.grigo-landing ol {
  padding: 0;
  list-style: none;
}

.grigo-landing a {
  color: var(--blue-ink);
  text-underline-offset: 3px;
}

.grigo-landing button {
  font: inherit;
  color: inherit;
  cursor: pointer;
}

.grigo-landing :focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 3px;
  border-radius: 6px;
}

.grigo-landing .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

.grigo-landing [hidden] {
  display: none !important;
}

.grigo-landing .skip {
  position: absolute;
  left: 12px;
  top: -64px;
  z-index: 100;
  background: var(--brand);
  color: var(--on-brand);
  padding: 10px 18px;
  border-radius: 999px;
  font-weight: 650;
}

.grigo-landing .skip:focus {
  top: 12px;
}

.grigo-landing h1,
.grigo-landing h2,
.grigo-landing h3 {
  color: var(--ink);
  text-wrap: balance;
}

.grigo-landing h1 {
  font-size: clamp(2.6rem, 6.3vw, 5.1rem);
  line-height: 1.02;
  letter-spacing: -0.038em;
  font-weight: 790;
}

.grigo-landing h2 {
  font-size: clamp(2.1rem, 4.4vw, 3.5rem);
  line-height: 1.05;
  letter-spacing: -0.034em;
  font-weight: 770;
}

.grigo-landing h3 {
  font-size: 1.2rem;
  line-height: 1.3;
  letter-spacing: -0.015em;
  font-weight: 700;
}

.grigo-landing p {
  text-wrap: pretty;
}

.grigo-landing .lead {
  font-size: clamp(1.1rem, 1.5vw, 1.3rem);
  line-height: 1.55;
  color: var(--ink-2);
  max-width: 60ch;
  font-weight: 450;
}

.grigo-landing .muted {
  color: var(--ink-3);
}

.grigo-landing .small {
  font-size: 0.9rem;
  line-height: 1.5;
}

.grigo-landing kbd {
  font-family: var(--mono);
  font-size: 0.82em;
  font-weight: 500;
  padding: 2px 8px;
  border: 1px solid var(--line-strong);
  border-bottom-width: 2px;
  border-radius: var(--r-s);
  background: var(--surface);
  color: var(--ink);
}

.grigo-landing .ic {
  width: 20px;
  height: 20px;
  flex: none;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.grigo-landing .ic-sm {
  width: 16px;
  height: 16px;
}

.grigo-landing .ic-lg {
  width: 24px;
  height: 24px;
}

.grigo-landing .ico {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  flex: none;
  color: var(--ic, var(--blue-ink));
  background: var(--icbg, var(--blue-soft));
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);
}

.grigo-landing .ico--sage {
  --ic: var(--sage-ink);
  --icbg: var(--sage-soft);
}

.grigo-landing .ico--blue {
  --ic: var(--blue-ink);
  --icbg: var(--blue-soft);
}

.grigo-landing .ico--amber {
  --ic: var(--amber-ink);
  --icbg: var(--amber-soft);
}

.grigo-landing .ico--sm {
  width: 38px;
  height: 38px;
  border-radius: 12px;
}

.grigo-landing .pm {
  width: 14px;
  height: 14px;
  flex: none;
}

.grigo-landing .pm-openai {
  color: var(--blue-gfx);
}

.grigo-landing .pm-anthropic {
  color: var(--tan-gfx);
}

.grigo-landing .pm-google {
  color: var(--amber-gfx);
}

.grigo-landing .wrap {
  width: 100%;
  max-width: 1240px;
  margin-inline: auto;
  padding-inline: clamp(20px, 4vw, 40px);
}

.grigo-landing .section {
  position: relative;
  padding-block: clamp(52px, 7vw, 96px);
  scroll-margin-top: 20px;
}

.grigo-landing .center-head {
  display: grid;
  justify-items: center;
  text-align: center;
  gap: 20px;
  margin: 0 auto clamp(28px, 4vw, 48px);
  max-width: 860px;
}

.grigo-landing .center-head .lead {
  margin-inline: auto;
}

.grigo-landing .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 52px;
  padding: 0 28px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-weight: 680;
  font-size: 1.02rem;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
  transition:
    transform 160ms ease-out,
    box-shadow 160ms ease-out,
    background-color 160ms ease-out;
}

.grigo-landing .btn:hover {
  text-decoration: none;
  transform: translateY(-1px);
}

.grigo-landing .btn-primary {
  background: var(--brand-grad);
  color: var(--on-brand);
  box-shadow:
    var(--btn-glow),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

.grigo-landing .btn-primary:hover {
  color: var(--on-brand);
  box-shadow:
    0 14px 30px -10px rgba(43, 74, 120, 0.85),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

.grigo-landing .btn-secondary {
  background: var(--glass);
  color: var(--ink);
  border-color: var(--line-strong);
  backdrop-filter: blur(10px);
}

.grigo-landing .btn-secondary:hover {
  background: var(--surface);
  color: var(--ink);
}

.grigo-landing .btn-sm {
  min-height: 40px;
  padding: 0 18px;
  font-size: 0.93rem;
}

.grigo-landing .btn[aria-disabled='true'] {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
}

.grigo-landing .btn-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}

.grigo-landing .chip {
  min-height: 36px;
  padding: 0 16px;
  border-radius: 999px;
  background: var(--surface);
  border: 1px solid var(--line-strong);
  font-size: 0.9rem;
  font-weight: 620;
  color: var(--ink);
  transition:
    background-color 140ms ease-out,
    transform 140ms ease-out;
}

.grigo-landing .chip:hover {
  background: var(--surface-2);
  transform: translateY(-1px);
}

.grigo-landing .tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 11px;
  border-radius: 999px;
  border: 1px solid var(--line-strong);
  font-size: 0.8rem;
  font-weight: 650;
  color: var(--ink-2);
  background: var(--surface);
  white-space: nowrap;
}

.grigo-landing .site-header {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 60;
  padding: 14px clamp(12px, 3vw, 32px) 0;
  pointer-events: none;
}

.grigo-landing .nav-pill {
  pointer-events: auto;
  position: relative;
  max-width: 1160px;
  margin-inline: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 8px 8px 20px;
  border-radius: 999px;
  background: var(--nav-bg);
  border: 1px solid var(--glass-line);
  backdrop-filter: blur(20px) saturate(1.5);
  box-shadow:
    var(--sh-1),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
  transition: box-shadow 200ms ease-out;
}

.grigo-landing .site-header.scrolled .nav-pill {
  box-shadow:
    var(--sh-2),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.grigo-landing .brand {
  display: inline-flex;
  align-items: center;
  flex: none;
  text-decoration: none;
  color: var(--ink);
}

.grigo-landing .brand img {
  height: 40px;
  width: auto;
  max-width: none;
}

.grigo-landing .nav {
  display: flex;
  flex-wrap: nowrap;
  gap: 2px;
  margin: 0 auto;
  padding: 0;
  margin-bottom: 0;
}

.grigo-landing .nav a {
  padding: 8px 14px;
  border-radius: 999px;
  text-decoration: none;
  color: var(--ink-2);
  font-weight: 620;
  font-size: 0.95rem;
  white-space: nowrap;
  transition:
    background-color 140ms ease-out,
    color 140ms ease-out;
}

.grigo-landing .nav a:hover {
  background: var(--surface-3);
  color: var(--ink);
}

.grigo-landing .nav .nav-cta {
  display: none;
}

.grigo-landing .header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: none;
}

.grigo-landing .icon-btn {
  min-width: 42px;
  height: 42px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: transparent;
  border: 1px solid var(--line-strong);
  border-radius: 999px;
  font-weight: 620;
  font-size: 0.9rem;
}

.grigo-landing .icon-btn:hover {
  background: var(--surface-3);
}

.grigo-landing .menu-btn {
  display: none;
}

.grigo-landing .window-wrap {
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: clamp(28px, 3.5vw, 44px) auto 0;
  text-align: left;
  padding: 1px;
  border-radius: 29px;
  box-shadow: var(--sh-window);
  background: linear-gradient(
    135deg,
    rgba(124, 151, 144, 0.9),
    rgba(98, 126, 163, 0.9) 50%,
    rgba(227, 163, 62, 0.9)
  );
  scroll-margin-top: 96px;
}

.grigo-landing .window {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 356px;
  min-height: 0;
  border-radius: 28px;
  background: var(--surface);
  overflow: hidden;
}

.grigo-landing .win-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.grigo-landing .win-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 22px;
  border-bottom: 1px solid var(--line);
}

.grigo-landing .win-title {
  font-weight: 700;
  font-size: 1.02rem;
  letter-spacing: -0.01em;
}

.grigo-landing .chip-static {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  background: var(--surface-2);
  border: 1px solid var(--line);
  font-size: 0.8rem;
  font-weight: 650;
  color: var(--ink-2);
  white-space: nowrap;
}

.grigo-landing .chip-static + .chip-static {
  margin-left: 6px;
}

.grigo-landing .chip-static .sep {
  width: 1px;
  height: 12px;
  background: var(--line-strong);
  opacity: 0.5;
}

.grigo-landing .composer {
  margin: 20px 20px 0;
  border: 1px solid var(--line-strong);
  border-radius: 22px;
  background: var(--surface);
  box-shadow: var(--sh-1);
}

.grigo-landing .composer:focus-within {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.grigo-landing .field {
  position: relative;
}

.grigo-landing .field .hl,
.grigo-landing .field textarea {
  display: block;
  width: 100%;
  height: 100px;
  margin: 0;
  padding: 16px 18px 6px;
  font: inherit;
  font-size: 1rem;
  line-height: 1.55;
  letter-spacing: 0;
  font-weight: 450;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  border: 0;
  border-radius: 22px 22px 0 0;
  scrollbar-gutter: stable;
}

.grigo-landing .field .hl {
  position: absolute;
  inset: 0;
  overflow: hidden;
  color: transparent;
  pointer-events: none;
}

.grigo-landing .field textarea {
  position: relative;
  resize: none;
  overflow-y: auto;
  background: transparent;
  color: var(--ink);
  outline: none;
  caret-color: var(--ink);
}

.grigo-landing .hl mark {
  color: transparent;
  border-radius: 3px;
  padding: 1px 0;
}

.grigo-landing .t1 {
  background: var(--warn-soft);
  -webkit-text-decoration: underline dotted 2px var(--warn);
          text-decoration: underline dotted 2px var(--warn);
  text-underline-offset: 4px;
}

.grigo-landing .t2 {
  background: var(--blue-soft);
  -webkit-text-decoration: underline dashed 2px var(--blue-ink);
          text-decoration: underline dashed 2px var(--blue-ink);
  text-underline-offset: 4px;
}

.grigo-landing .t3 {
  background: var(--err-soft);
  -webkit-text-decoration: underline solid 3px var(--err);
          text-decoration: underline solid 3px var(--err);
  text-underline-offset: 4px;
}

.grigo-landing .composer-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px 10px 14px;
  color: var(--ink-3);
}

.grigo-landing .composer-bar .grow {
  flex: 1 1;
}

.grigo-landing .send {
  flex: none;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 0;
  display: grid;
  place-items: center;
  background: var(--brand-grad);
  color: var(--on-brand);
  box-shadow: var(--btn-glow);
  transition: transform 140ms ease-out;
}

.grigo-landing .send:hover {
  transform: translateY(-1px);
}

.grigo-landing .send[aria-disabled='true'] {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.grigo-landing .pii-bar {
  margin: 12px 20px 20px;
  display: grid;
  gap: 4px;
}

.grigo-landing .banner {
  border-radius: 14px;
  padding: 12px 16px;
  font-size: 0.92rem;
  line-height: 1.5;
  color: var(--ink-2);
  background: var(--surface-2);
  border: 1px solid var(--line);
  border-left: 4px solid var(--line-strong);
}

.grigo-landing .banner strong {
  color: var(--ink);
}

.grigo-landing .banner--warn {
  border-left-color: var(--warn);
  background: var(--warn-soft);
}

.grigo-landing .banner--mask {
  border-left-color: var(--blue-ink);
  background: var(--blue-soft);
}

.grigo-landing .banner--block {
  border-left-color: var(--err);
  background: var(--err-soft);
}

.grigo-landing .banner--ok {
  border-left-color: var(--ok);
  background: var(--ok-soft);
}

.grigo-landing .demo-msg {
  font-size: 0.88rem;
  color: var(--ink-2);
  min-height: 1.3em;
  padding-left: 4px;
}

.grigo-landing .panel {
  background: var(--surface-2);
  border-left: 1px solid var(--line);
  padding: 20px 20px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}

.grigo-landing .panel-title {
  font-size: 1.15rem;
  letter-spacing: -0.02em;
  display: flex;
  align-items: center;
  gap: 10px;
}

.grigo-landing .demo-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.grigo-landing .demo-presets .chip {
  min-height: 32px;
  padding: 0 13px;
  font-size: 0.84rem;
}

.grigo-landing .findings {
  display: grid;
  gap: 8px;
}

.grigo-landing .findings li {
  padding: 10px 12px;
  border-radius: 14px;
  background: var(--surface);
  border: 1px solid var(--line);
  display: grid;
  gap: 4px;
  font-size: 0.9rem;
}

.grigo-landing .f-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.grigo-landing .tier {
  display: inline-flex;
  gap: 6px;
  align-items: baseline;
  font-weight: 700;
  padding: 1px 9px;
  border-radius: 999px;
  font-size: 0.78rem;
  text-decoration: none;
}

.grigo-landing .tier span {
  font-weight: 500;
}

.grigo-landing .tier.t1 {
  color: var(--warn);
  background: transparent;
  text-decoration: none;
}

.grigo-landing .tier.t2 {
  color: var(--blue-ink);
  background: transparent;
  text-decoration: none;
}

.grigo-landing .tier.t3 {
  color: var(--err);
  background: transparent;
  text-decoration: none;
}

.grigo-landing .f-res {
  font-weight: 700;
  font-size: 0.82rem;
  color: var(--ink);
}

.grigo-landing .f-type {
  font-weight: 620;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.grigo-landing .f-type code {
  font-family: var(--mono);
  font-size: 0.82em;
  font-weight: 500;
  color: var(--ink-3);
}

.grigo-landing .seen {
  border: 1px dashed var(--line-strong);
  border-radius: 14px;
  padding: 12px 14px;
  display: grid;
  gap: 6px;
  background: var(--surface);
  margin: 0 20px 20px;
}

.grigo-landing .seen h3 {
  font-size: 0.92rem;
}

.grigo-landing .seen-text {
  font-size: 0.93rem;
  line-height: 1.55;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  color: var(--ink);
}

.grigo-landing .token {
  font-family: var(--mono);
  font-size: 0.82em;
  padding: 1px 7px;
  border: 1px dashed var(--blue-ink);
  border-radius: 6px;
  color: var(--blue-ink);
  background: var(--blue-soft);
  white-space: nowrap;
}

.grigo-landing .demo-foot {
  font-size: 0.8rem;
  color: var(--ink-3);
  margin-top: auto;
}

.grigo-landing .cta {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  text-align: center;
  display: grid;
  justify-items: center;
  gap: 24px;
  padding: clamp(48px, 8vw, 104px) clamp(24px, 5vw, 64px);
  border-radius: 36px;
  background: var(--surface);
  border: 1px solid var(--line);
  box-shadow: var(--sh-2);
}

.grigo-landing .cta::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
  opacity: var(--aurora-o);
  background:
    radial-gradient(45% 70% at 12% 20%, var(--aurora-a), transparent 70%),
    radial-gradient(45% 70% at 90% 15%, var(--aurora-b), transparent 70%),
    radial-gradient(40% 60% at 55% 110%, var(--aurora-c), transparent 70%);
}

.grigo-landing .cta h2 {
  max-width: 16ch;
}

.grigo-landing .hero {
  position: relative;
  isolation: isolate;
  padding: clamp(104px, 9vw, 124px) 0 clamp(36px, 4vw, 56px);
  overflow: hidden;
}

.grigo-landing .aurora {
  position: absolute;
  inset: 0;
  z-index: -1;
  overflow: hidden;
  pointer-events: none;
}

.grigo-landing .aurora i {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: var(--aurora-o);
}

.grigo-landing .aurora .a1 {
  width: 640px;
  height: 640px;
  left: -10%;
  top: -18%;
  background: var(--aurora-a);
}

.grigo-landing .aurora .a2 {
  width: 760px;
  height: 760px;
  right: -12%;
  top: -22%;
  background: var(--aurora-b);
}

.grigo-landing .aurora .a3 {
  width: 560px;
  height: 560px;
  left: 30%;
  top: 22%;
  background: var(--aurora-c);
  opacity: calc(var(--aurora-o) * 0.6);
}

.grigo-landing .hero::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  background-image: repeating-linear-gradient(90deg, var(--line) 0 1px, transparent 1px 88px);
  background-position: 20px 0;
  mask-image: radial-gradient(ellipse 70% 60% at 50% 20%, #000 0%, transparent 75%);
}

.grigo-landing .hero-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.05fr);
  gap: clamp(28px, 4.5vw, 64px);
  align-items: center;
}

.grigo-landing .hero-copy {
  display: grid;
  gap: 22px;
  justify-items: start;
  text-align: left;
}

.grigo-landing .hero h1 {
  font-size: clamp(2.3rem, 4.4vw, 3.6rem);
  line-height: 1.04;
  max-width: 12em;
}

.grigo-landing .hero .lead {
  max-width: 46ch;
  margin: 0;
}

.grigo-landing .hero-copy .btn-row {
  justify-content: flex-start;
}

.grigo-landing .stats {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 36px;
  padding-top: 20px;
  border-top: 1px solid var(--line-strong);
  width: 100%;
  max-width: 560px;
}

.grigo-landing .stats div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.grigo-landing .stats dd {
  order: 1;
  font-size: 2rem;
  font-weight: 780;
  letter-spacing: -0.03em;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.grigo-landing .stats dt {
  order: 2;
  font-size: 0.86rem;
  color: var(--ink-2);
  font-weight: 600;
}

.grigo-landing .hub {
  --blue-gfx: #7fa2db;
  --tan-gfx: #c9a56a;
  --amber-gfx: #e3a63f;
  position: relative;
  isolation: isolate;
  border-radius: var(--r-xl);
  padding: 22px 22px 16px;
  color: #eef2f8;
  text-align: left;
  overflow: hidden;
  background:
    radial-gradient(55% 48% at 50% 46%, rgba(143, 176, 230, 0.2), transparent 72%), #0c1630;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: var(--sh-window);
}

.grigo-landing .hub::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  background-image: radial-gradient(rgba(255, 255, 255, 0.09) 1px, transparent 1px);
  background-size: 18px 18px;
  mask-image: radial-gradient(ellipse 85% 75% at 50% 46%, #000, transparent 88%);
}

.grigo-landing .hub-top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 0.85rem;
  font-weight: 650;
  color: #c3cddf;
}

.grigo-landing .hub-top .live {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.grigo-landing .hub-top .live::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #8fd1ac;
  box-shadow: 0 0 10px #8fd1ac;
}

.grigo-landing .hub-stage {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(20px, 0.45fr) 100px minmax(20px, 0.45fr) minmax(
      0,
      1fr
    );
  height: 300px;
}

.grigo-landing .hub-col {
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  align-items: center;
}

.grigo-landing .hn {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 56px;
  padding: 8px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: #fff;
  font-weight: 650;
  font-size: 0.9rem;
  line-height: 1.2;
}

.grigo-landing .hub-out {
  grid-template-rows: repeat(4, 1fr);
}

.grigo-landing .hn.more {
  border-style: dashed;
  color: #c3cddf;
}

.grigo-landing .hn small {
  display: block;
  color: #9facc4;
  font-weight: 500;
  font-size: 0.76rem;
}

.grigo-landing .hn .ic {
  color: #9db9e6;
}

.grigo-landing .hub-lines {
  display: block;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.grigo-landing .hub-lines path {
  fill: none;
  vector-effect: non-scaling-stroke;
}

.grigo-landing .hub-lines .base {
  stroke: rgba(255, 255, 255, 0.16);
  stroke-width: 1.5;
}

.grigo-landing .hub-lines .flow {
  stroke: #8fb0e6;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-dasharray: 3 12;
}

.grigo-landing .hub-core {
  position: relative;
  align-self: center;
  justify-self: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: linear-gradient(180deg, #24427a, #14264b);
  border: 1px solid rgba(143, 176, 230, 0.65);
  box-shadow:
    0 0 40px rgba(143, 176, 230, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.grigo-landing .hub-core img {
  height: 34px;
  width: auto;
  max-width: 78px;
}

.grigo-landing .ring {
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  border: 1px solid rgba(143, 176, 230, 0.55);
  pointer-events: none;
}

.grigo-landing .hub-feats {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}

.grigo-landing .hub-feats .tag {
  background: rgba(255, 255, 255, 0.07);
  color: #eef2f8;
  border-color: rgba(255, 255, 255, 0.2);
}

.grigo-landing .feat-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.grigo-landing .feat {
  position: relative;
  display: grid;
  gap: 10px;
  align-content: start;
  padding: 26px 24px 24px;
  border-radius: var(--r-l);
  background: var(--surface);
  border: 1px solid var(--line);
  box-shadow: var(--sh-1);
  transition:
    transform 200ms ease-out,
    box-shadow 200ms ease-out,
    border-color 200ms ease-out;
}

.grigo-landing .feat:hover {
  transform: translateY(-2px);
  box-shadow: var(--sh-2);
  border-color: var(--blue-gfx);
}

.grigo-landing .feat .ico {
  margin-bottom: 4px;
}

.grigo-landing .feat h3 {
  font-size: 1.15rem;
}

.grigo-landing .feat p {
  color: var(--ink-2);
  font-size: 0.97rem;
  line-height: 1.5;
}

.grigo-landing .feat .spec-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.grigo-landing .cost-grid,
.grigo-landing .story-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.05fr);
  gap: 24px;
  align-items: stretch;
}

.grigo-landing .levers {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.grigo-landing .levers .feat {
  padding: 20px 18px 18px;
}

.grigo-landing .levers .feat h3 {
  font-size: 1.05rem;
}

.grigo-landing .levers .feat p {
  font-size: 0.93rem;
}

.grigo-landing .card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-xl);
  box-shadow: var(--sh-1);
  padding: 24px 26px;
  display: grid;
  gap: 16px;
  align-content: start;
  min-width: 0;
  color: var(--ink);
}

.grigo-landing .card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.grigo-landing .card-head h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
}

.grigo-landing .kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.grigo-landing .kpi {
  padding: 12px 14px;
  border-radius: 14px;
  background: var(--surface-2);
  border: 1px solid var(--line);
  display: grid;
  gap: 2px;
}

.grigo-landing .kpi b {
  font-size: 1.45rem;
  letter-spacing: -0.03em;
  line-height: 1.15;
  font-variant-numeric: tabular-nums;
  color: var(--ink);
}

.grigo-landing .kpi span {
  font-size: 0.8rem;
  color: var(--ink-3);
  font-weight: 620;
}

.grigo-landing .brow {
  display: grid;
  grid-template-columns: 108px minmax(0, 1fr) auto;
  gap: 14px;
  align-items: center;
  font-size: 0.93rem;
}

.grigo-landing .brow > span:first-child {
  font-weight: 650;
  color: var(--ink);
}

.grigo-landing .brow .amt {
  font-variant-numeric: tabular-nums;
  color: var(--ink-2);
  font-weight: 600;
  white-space: nowrap;
  text-align: right;
  min-width: 108px;
}

.grigo-landing .meter {
  height: 10px;
  border-radius: 999px;
  background: var(--surface-3);
  overflow: hidden;
}

.grigo-landing .meter > i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--sage-gfx);
}

.grigo-landing .meter > i.warn {
  background: var(--amber-gfx);
}

.grigo-landing .meter > i.over {
  background: var(--err);
}

.grigo-landing .story-list {
  display: grid;
  gap: 14px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.grigo-landing .story-list li {
  display: grid;
  gap: 2px;
}

.grigo-landing .story-list strong {
  font-size: 0.98rem;
}

.grigo-landing .story-list span {
  color: var(--ink-2);
  font-size: 0.93rem;
  line-height: 1.45;
}

.grigo-landing .flow-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.grigo-landing .flow-step {
  display: grid;
  gap: 8px;
  align-content: start;
  padding: 22px 20px;
  border-radius: var(--r-l);
  background: var(--surface);
  border: 1px solid var(--line);
  box-shadow: var(--sh-1);
}

.grigo-landing .flow-step b {
  font-size: 0.78rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--blue-ink);
}

.grigo-landing .flow-step p {
  color: var(--ink-2);
  font-size: 0.95rem;
  line-height: 1.5;
}

.grigo-landing .specs-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-xl);
  box-shadow: var(--sh-1);
  padding: 6px 32px;
}

.grigo-landing .specs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 56px;
}

.grigo-landing .spec {
  display: grid;
  grid-template-columns: 132px minmax(0, 1fr);
  gap: 16px;
  align-items: baseline;
  padding: 16px 0;
  border-bottom: 1px solid var(--line);
}

.grigo-landing .spec:nth-last-child(-n + 2) {
  border-bottom: 0;
}

.grigo-landing .spec dt {
  color: var(--ink-3);
  font-weight: 650;
  font-size: 0.9rem;
}

.grigo-landing .spec dd {
  font-weight: 600;
  color: var(--ink);
  font-size: 0.97rem;
  line-height: 1.45;
}

.grigo-landing .site-footer {
  padding: 36px 0 30px;
  border-top: 1px solid var(--line);
}

.grigo-landing .footer-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px 28px;
}

.grigo-landing .footer-id {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: none;
  min-width: 0;
}

.grigo-landing .footer-id .brand {
  margin-right: 0;
}

.grigo-landing .site-footer nav {
  flex: 1 1 280px;
  min-width: 0;
}

.grigo-landing .site-footer ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px 24px;
}

.grigo-landing .site-footer li a {
  color: var(--ink-2);
  text-decoration: none;
  font-weight: 560;
  font-size: 0.95rem;
}

.grigo-landing .site-footer li a:hover {
  color: var(--ink);
  text-decoration: underline;
}

.grigo-landing .footer-note {
  margin: 0;
  color: var(--ink-3);
  font-size: 0.86rem;
  line-height: 1.2;
  white-space: nowrap;
}

.grigo-landing .demo-dialog {
  border: 0;
  padding: 0;
  width: min(520px, calc(100vw - 24px));
  min-width: min(520px, calc(100vw - 24px));
  max-height: calc(100dvh - 24px);
  overflow: auto;
  border-radius: var(--r-xl);
  background: var(--surface);
  color: var(--ink);
  box-shadow: var(--sh-window);
}

.grigo-landing .demo-dialog[open] {
  display: block;
}

.grigo-landing .demo-dialog::backdrop {
  background: rgba(8, 15, 30, 0.58);
  backdrop-filter: blur(4px);
}

.grigo-landing .modal-box {
  position: relative;
  display: grid;
  gap: 14px;
  padding: 28px 28px 24px;
}

.grigo-landing .demo-dialog h2 {
  font-size: 1.7rem;
  line-height: 1.1;
  letter-spacing: -0.03em;
  padding-right: 44px;
}

.grigo-landing .modal-x {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border: 1px solid var(--line-strong);
  border-radius: 50%;
  background: transparent;
}

.grigo-landing .modal-x:hover {
  background: var(--surface-3);
}

.grigo-landing .demo-form {
  display: grid;
  gap: 14px;
  margin-top: 4px;
}

.grigo-landing .fg {
  display: grid;
  gap: 6px;
}

.grigo-landing .fg label {
  display: grid;
  gap: 6px;
  font-weight: 650;
  font-size: 0.92rem;
}

.grigo-landing .fg .opt {
  color: var(--ink-3);
  font-weight: 500;
}

.grigo-landing .fg input,
.grigo-landing .fg select,
.grigo-landing .fg textarea {
  width: 100%;
  font: inherit;
  font-size: 1rem;
  color: var(--ink);
  background: var(--surface);
  border: 1px solid var(--line-strong);
  border-radius: 12px;
  padding: 11px 14px;
  min-height: 46px;
}

.grigo-landing .fg textarea {
  resize: vertical;
  min-height: 84px;
}

.grigo-landing .fg [aria-invalid='true'] {
  border-color: var(--err);
  box-shadow: 0 0 0 1px var(--err);
}

.grigo-landing .err-msg {
  color: var(--err);
  font-size: 0.86rem;
  font-weight: 600;
}

.grigo-landing .bd-alert {
  padding: 12px 14px;
  border-radius: 12px;
  background: var(--err-soft);
  border-left: 4px solid var(--err);
  font-size: 0.93rem;
}

.grigo-landing .bd-hp {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.grigo-landing .demo-form .btn {
  width: 100%;
}

.grigo-landing .demo-form .btn[disabled] {
  opacity: 0.6;
  cursor: progress;
}

.grigo-landing .bd-done {
  display: grid;
  align-content: center;
  min-height: 168px;
  outline: none;
}

@media (prefers-reduced-motion: no-preference) {
  .grigo-landing .aurora .a1 {
    animation: gl-drift1 26s ease-in-out infinite alternate;
  }

  .grigo-landing .aurora .a2 {
    animation: gl-drift2 32s ease-in-out infinite alternate;
  }

  .grigo-landing .aurora .a3 {
    animation: gl-drift1 38s ease-in-out infinite alternate-reverse;
  }

  .grigo-landing .rise {
    animation: gl-rise 900ms cubic-bezier(0.2, 0.7, 0.2, 1) both;
    animation-delay: calc(var(--d, 0) * 90ms);
  }

  .grigo-landing .hub.anim .flow {
    animation: gl-dash 1.4s linear infinite;
  }

  .grigo-landing .hub.anim .ring {
    animation: gl-ping 3.2s ease-out infinite;
  }

  .grigo-landing .hub.anim .ring.r2 {
    animation-delay: 1.6s;
  }

  .grigo-landing .hub.anim .hub-in .hn {
    animation: gl-act 9s ease-in-out infinite;
  }

  .grigo-landing .hub.anim .hub-in .hn:nth-child(2) {
    animation-delay: 3s;
  }

  .grigo-landing .hub.anim .hub-in .hn:nth-child(3) {
    animation-delay: 6s;
  }

  .grigo-landing .hub.anim .hub-out .hn {
    animation: gl-act 9s ease-in-out infinite;
    animation-delay: 1.4s;
  }

  .grigo-landing .hub.anim .hub-out .hn:nth-child(2) {
    animation-delay: 3.65s;
  }

  .grigo-landing .hub.anim .hub-out .hn:nth-child(3) {
    animation-delay: 5.9s;
  }

  .grigo-landing .hub.anim .hub-out .hn:nth-child(4) {
    animation-delay: 8.15s;
  }

  .grigo-landing .reveal {
    opacity: 0;
    transform: translateY(18px);
    transition:
      opacity 600ms ease-out,
      transform 600ms ease-out;
  }

  .grigo-landing .reveal.in {
    opacity: 1;
    transform: none;
  }

  .grigo-landing .demo-dialog[open] {
    animation: gl-pop 220ms ease-out;
  }

  .grigo-landing .demo-dialog[open]::backdrop {
    animation: gl-fadein 220ms ease-out;
  }
}

@keyframes gl-drift1 {
  to {
    transform: translate3d(90px, 50px, 0) scale(1.08);
  }
}

@keyframes gl-drift2 {
  to {
    transform: translate3d(-110px, 70px, 0) scale(1.1);
  }
}

@keyframes gl-rise {
  from {
    opacity: 0;
    transform: translateY(18px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes gl-dash {
  to {
    stroke-dashoffset: -30;
  }
}

@keyframes gl-ping {
  0% {
    transform: scale(0.85);
    opacity: 0.8;
  }

  100% {
    transform: scale(1.55);
    opacity: 0;
  }
}

@keyframes gl-act {
  0%,
  30% {
    border-color: #8fb0e6;
    background: rgba(143, 176, 230, 0.17);
    box-shadow:
      0 0 0 3px rgba(143, 176, 230, 0.16),
      0 0 22px rgba(143, 176, 230, 0.32);
  }

  38%,
  100% {
    border-color: rgba(255, 255, 255, 0.16);
    background: rgba(255, 255, 255, 0.06);
    box-shadow: 0 0 0 0 rgba(143, 176, 230, 0);
  }
}

@keyframes gl-pop {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes gl-fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@media (max-width: 1200px) {
  .grigo-landing .window {
    grid-template-columns: minmax(0, 1fr) 340px;
  }

  .grigo-landing .nav a {
    padding-inline: 10px;
  }

  .grigo-landing .header-actions .btn-sm {
    padding-inline: 14px;
  }
}

@media (max-width: 1000px) {
  .grigo-landing .nav {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 10px);
    flex-direction: column;
    background: var(--glass);
    border: 1px solid var(--glass-line);
    border-radius: 28px;
    padding: 10px;
    backdrop-filter: blur(20px);
    box-shadow: var(--sh-2);
    margin: 0;
  }

  .grigo-landing .nav.open {
    display: flex;
  }

  .grigo-landing .nav a {
    padding: 14px 16px;
  }

  .grigo-landing .nav .nav-cta {
    display: block;
    background: var(--brand-grad);
    color: var(--on-brand);
    text-align: center;
    margin-top: 6px;
  }

  .grigo-landing .nav .nav-cta:hover {
    background: var(--brand-grad);
    color: var(--on-brand);
  }

  .grigo-landing .menu-btn {
    display: inline-flex;
  }

  .grigo-landing .header-actions .btn {
    display: none;
  }

  .grigo-landing .brand {
    margin-right: auto;
  }

  .grigo-landing .hero-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .grigo-landing .hero-copy {
    justify-items: center;
    text-align: center;
  }

  .grigo-landing .hero h1 {
    max-width: 14em;
  }

  .grigo-landing .hero-copy .btn-row,
  .grigo-landing .stats {
    justify-content: center;
  }

  .grigo-landing .window {
    grid-template-columns: minmax(0, 1fr);
  }

  .grigo-landing .panel {
    border-left: 0;
    border-top: 1px solid var(--line);
  }

  .grigo-landing .feat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .grigo-landing .cost-grid,
  .grigo-landing .story-grid,
  .grigo-landing .flow-steps {
    grid-template-columns: minmax(0, 1fr);
  }

  .grigo-landing .specs {
    grid-template-columns: minmax(0, 1fr);
  }

  .grigo-landing .spec:nth-last-child(2) {
    border-bottom: 1px solid var(--line);
  }
}

@media (max-width: 680px) {
  .grigo-landing .hero {
    padding-top: 100px;
  }

  .grigo-landing .win-head {
    flex-direction: column;
    align-items: flex-start;
  }

  .grigo-landing .field .hl,
  .grigo-landing .field textarea {
    height: 156px;
  }

  .grigo-landing .feat-grid,
  .grigo-landing .levers,
  .grigo-landing .kpis {
    grid-template-columns: minmax(0, 1fr);
  }

  .grigo-landing .brow {
    grid-template-columns: 88px minmax(0, 1fr);
  }

  .grigo-landing .brow .amt {
    grid-column: 1 / -1;
    text-align: left;
    min-width: 0;
  }

  .grigo-landing .spec {
    grid-template-columns: minmax(0, 1fr);
    gap: 4px;
  }

  .grigo-landing .specs-card {
    padding: 4px 20px;
  }

  .grigo-landing .cta {
    border-radius: 28px;
  }

  .grigo-landing .site-footer ul {
    justify-content: flex-start;
  }
}

@media (max-width: 480px) {
  .grigo-landing .hub {
    padding: 18px 14px 14px;
  }

  .grigo-landing .hub-stage {
    grid-template-columns: minmax(0, 1fr) 16px 76px 16px minmax(0, 1fr);
    height: 270px;
  }

  .grigo-landing .hub-core {
    width: 76px;
    height: 76px;
  }

  .grigo-landing .hn small,
  .grigo-landing .hn .ic {
    display: none;
  }

  .grigo-landing .hn {
    padding: 8px;
    font-size: 0.82rem;
    min-height: 48px;
  }

  .grigo-landing .modal-box {
    padding: 24px 20px 20px;
  }

  .grigo-landing .demo-dialog h2 {
    font-size: 1.45rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .grigo-landing,
  .grigo-landing *,
  .grigo-landing *::before,
  .grigo-landing *::after {
    transition: none !important;
    animation: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/landing/landing.css"],"names":[],"mappings":"AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kCAAkC;EAClC,sCAAsC;EACtC,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;EAChB,+DAA+D;EAC/D,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kFAAkF;EAClF,iFAAiF;EACjF,iGAAiG;EACjG,qDAAqD;EACrD,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iGAAiG;EACjG,kFAAkF;EAClF,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,sCAAsC;IACtC,gCAAgC;IAChC,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,sBAAsB;IACtB,gBAAgB;IAChB,+DAA+D;IAC/D,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,0EAA0E;IAC1E,0EAA0E;IAC1E,8FAA8F;IAC9F,uDAAuD;EACzD;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,8BAA8B;EAC9B,sCAAsC;EACtC,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;EACtB,gBAAgB;EAChB,+DAA+D;EAC/D,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,0EAA0E;EAC1E,0EAA0E;EAC1E,8FAA8F;EAC9F,uDAAuD;AACzD;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;;;;;EAUE,SAAS;AACX;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;;;EAGE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,iCAAiC;EACjC,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB;;;mCAGiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB;;2CAEyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB;;2CAEyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB;;4BAE0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,mCAAmC;EACnC,yCAAyC;EACzC;;0CAEwC;EACxC,qCAAqC;AACvC;;AAEA;EACE;;0CAEwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB;;wBAEsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,uCAAuC;EACvC,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B;;;;;GAKC;EACD,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;EACT,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,yDAAiD;UAAjD,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,6DAAqD;UAArD,qDAAqD;EACrD,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,uDAA+C;UAA/C,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;EAC7B,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,uDAAuD;EACvD,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,wBAAwB;EACxB;;;0EAGwE;AAC1E;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0DAA0D;EAC1D,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,2FAA2F;EAC3F,2BAA2B;EAE3B,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB;2FACyF;EACzF,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,iFAAiF;EACjF,0BAA0B;EAE1B,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb;;;KAGG;EACH,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,2CAA2C;EAC3C;;0CAEwC;AAC1C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB;;;+BAG6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,uDAAuD;EACvD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,yCAAyC;EACzC,+BAA+B;EAC/B,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE;IACE,uDAAuD;EACzD;;EAEA;IACE,uDAAuD;EACzD;;EAEA;IACE,+DAA+D;EACjE;;EAEA;IACE,4DAA4D;IAC5D,yCAAyC;EAC3C;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yCAAyC;IACzC,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,2BAA2B;IAC3B;;8BAE0B;EAC5B;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,iDAAiD;EACnD;AACF;;AAEA;EACE;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,qBAAqB;IACrB,qCAAqC;IACrC;;wCAEoC;EACtC;;EAEA;;IAEE,uCAAuC;IACvC,qCAAqC;IACrC,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,sBAAsB;IACtB,sBAAsB;IACtB,wBAAwB;IACxB,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,iCAAiC;EACnC;;EAEA;IACE,gDAAgD;EAClD;;EAEA;;;IAGE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;;IAGE,qCAAqC;EACvC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mEAAmE;IACnE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;IAIE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Hanken+Grotesk:ital,wght@0,100..900;1,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap');\n\n.grigo-landing {\n  color-scheme: light;\n  --bg: #f2f5fb;\n  --surface: #ffffff;\n  --surface-2: #f0f4fa;\n  --surface-3: #e4eaf4;\n  --glass: rgba(255, 255, 255, 0.72);\n  --glass-line: rgba(255, 255, 255, 0.9);\n  --nav-bg: rgba(255, 255, 255, 0.88);\n  --ink: #0f1a33;\n  --ink-2: #37435f;\n  --ink-3: #566380;\n  --line: rgba(15, 26, 51, 0.1);\n  --line-strong: #7a889f;\n  --brand: #2b4a78;\n  --brand-grad: linear-gradient(180deg, #3d64a3 0%, #27467a 100%);\n  --on-brand: #ffffff;\n  --focus: #2b4a78;\n  --sage: #7c9790;\n  --sage-soft: #e4eee9;\n  --sage-ink: #3a6553;\n  --sage-gfx: #5e8a75;\n  --blue: #627ea3;\n  --blue-soft: #e3ebf6;\n  --blue-ink: #35588c;\n  --blue-gfx: #4e6f9e;\n  --amber: #e3a33e;\n  --amber-soft: #fbebd0;\n  --amber-ink: #8a5a0b;\n  --amber-gfx: #b77a12;\n  --tan-gfx: #8a6a3a;\n  --err: #a32b2b;\n  --err-soft: #f9e4e4;\n  --ok: #2f6b4a;\n  --ok-soft: #ddeee4;\n  --warn: #8a5a0b;\n  --warn-soft: #fbebd0;\n  --aurora-a: #9cc4b3;\n  --aurora-b: #8eace0;\n  --aurora-c: #f4be6b;\n  --aurora-o: 0.55;\n  --sh-1: 0 1px 2px rgba(15, 26, 51, 0.05), 0 10px 28px -14px rgba(15, 26, 51, 0.16);\n  --sh-2: 0 2px 4px rgba(15, 26, 51, 0.05), 0 28px 64px -28px rgba(15, 26, 51, 0.3);\n  --sh-window: 0 50px 120px -40px rgba(32, 62, 120, 0.55), 0 10px 30px -10px rgba(15, 26, 51, 0.14);\n  --btn-glow: 0 10px 24px -10px rgba(43, 74, 120, 0.75);\n  --r-s: 8px;\n  --r-m: 12px;\n  --r-l: 20px;\n  --r-xl: 28px;\n  --font: 'Hanken Grotesk', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;\n  --mono: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  min-height: 100vh;\n  margin: 0;\n  background: var(--bg);\n  color: var(--ink);\n  font-family: var(--font);\n  font-size: 1.0625rem;\n  line-height: 1.6;\n  font-weight: 450;\n  text-align: left;\n  -webkit-font-smoothing: antialiased;\n  overflow-x: hidden;\n}\n\n.grigo-landing,\n.grigo-landing *,\n.grigo-landing *::before,\n.grigo-landing *::after {\n  box-sizing: border-box;\n}\n\n.grigo-landing,\n.grigo-landing * {\n  font-family: var(--font);\n}\n\n@media (prefers-color-scheme: dark) {\n  .grigo-landing:not([data-theme='light']) {\n    color-scheme: dark;\n    --bg: #080f1e;\n    --surface: #111b30;\n    --surface-2: #17233c;\n    --surface-3: #1f2e4b;\n    --glass: rgba(20, 31, 54, 0.7);\n    --glass-line: rgba(255, 255, 255, 0.1);\n    --nav-bg: rgba(17, 27, 48, 0.86);\n    --ink: #eef2f8;\n    --ink-2: #c0cadc;\n    --ink-3: #9aa7bf;\n    --line: rgba(255, 255, 255, 0.11);\n    --line-strong: #6b7b99;\n    --brand: #8fb0e6;\n    --brand-grad: linear-gradient(180deg, #a9c4f0 0%, #84a6de 100%);\n    --on-brand: #0b1428;\n    --focus: #8fb0e6;\n    --sage-soft: #1b2f28;\n    --sage-ink: #9cc7b2;\n    --sage-gfx: #7fb39a;\n    --blue-soft: #1b2a47;\n    --blue-ink: #9db9e6;\n    --blue-gfx: #7fa2db;\n    --amber-soft: #3a2e14;\n    --amber-ink: #f0bc62;\n    --amber-gfx: #e3a63f;\n    --tan-gfx: #c9a56a;\n    --err: #f29b9b;\n    --err-soft: #3c1f24;\n    --ok: #8fd1ac;\n    --ok-soft: #1a3226;\n    --warn: #f0bc62;\n    --warn-soft: #3a2e14;\n    --aurora-a: #3e7a66;\n    --aurora-b: #3c5fb0;\n    --aurora-c: #b9791f;\n    --aurora-o: 0.4;\n    --sh-1: 0 1px 2px rgba(0, 0, 0, 0.3), 0 10px 28px -14px rgba(0, 0, 0, 0.6);\n    --sh-2: 0 2px 4px rgba(0, 0, 0, 0.3), 0 28px 64px -28px rgba(0, 0, 0, 0.8);\n    --sh-window: 0 50px 120px -40px rgba(60, 100, 200, 0.45), 0 10px 30px -10px rgba(0, 0, 0, 0.5);\n    --btn-glow: 0 10px 28px -10px rgba(143, 176, 230, 0.55);\n  }\n}\n\n.grigo-landing[data-theme='dark'] {\n  color-scheme: dark;\n  --bg: #080f1e;\n  --surface: #111b30;\n  --surface-2: #17233c;\n  --surface-3: #1f2e4b;\n  --glass: rgba(20, 31, 54, 0.7);\n  --glass-line: rgba(255, 255, 255, 0.1);\n  --nav-bg: rgba(17, 27, 48, 0.86);\n  --ink: #eef2f8;\n  --ink-2: #c0cadc;\n  --ink-3: #9aa7bf;\n  --line: rgba(255, 255, 255, 0.11);\n  --line-strong: #6b7b99;\n  --brand: #8fb0e6;\n  --brand-grad: linear-gradient(180deg, #a9c4f0 0%, #84a6de 100%);\n  --on-brand: #0b1428;\n  --focus: #8fb0e6;\n  --sage-soft: #1b2f28;\n  --sage-ink: #9cc7b2;\n  --sage-gfx: #7fb39a;\n  --blue-soft: #1b2a47;\n  --blue-ink: #9db9e6;\n  --blue-gfx: #7fa2db;\n  --amber-soft: #3a2e14;\n  --amber-ink: #f0bc62;\n  --amber-gfx: #e3a63f;\n  --tan-gfx: #c9a56a;\n  --err: #f29b9b;\n  --err-soft: #3c1f24;\n  --ok: #8fd1ac;\n  --ok-soft: #1a3226;\n  --warn: #f0bc62;\n  --warn-soft: #3a2e14;\n  --aurora-a: #3e7a66;\n  --aurora-b: #3c5fb0;\n  --aurora-c: #b9791f;\n  --aurora-o: 0.4;\n  --sh-1: 0 1px 2px rgba(0, 0, 0, 0.3), 0 10px 28px -14px rgba(0, 0, 0, 0.6);\n  --sh-2: 0 2px 4px rgba(0, 0, 0, 0.3), 0 28px 64px -28px rgba(0, 0, 0, 0.8);\n  --sh-window: 0 50px 120px -40px rgba(60, 100, 200, 0.45), 0 10px 30px -10px rgba(0, 0, 0, 0.5);\n  --btn-glow: 0 10px 28px -10px rgba(143, 176, 230, 0.55);\n}\n\n.grigo-landing img,\n.grigo-landing svg {\n  display: block;\n  max-width: 100%;\n}\n\n.grigo-landing h1,\n.grigo-landing h2,\n.grigo-landing h3,\n.grigo-landing h4,\n.grigo-landing p,\n.grigo-landing ul,\n.grigo-landing ol,\n.grigo-landing dl,\n.grigo-landing dd,\n.grigo-landing figure {\n  margin: 0;\n}\n\n.grigo-landing ul,\n.grigo-landing ol {\n  padding: 0;\n  list-style: none;\n}\n\n.grigo-landing a {\n  color: var(--blue-ink);\n  text-underline-offset: 3px;\n}\n\n.grigo-landing button {\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n}\n\n.grigo-landing :focus-visible {\n  outline: 2px solid var(--focus);\n  outline-offset: 3px;\n  border-radius: 6px;\n}\n\n.grigo-landing .sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.grigo-landing [hidden] {\n  display: none !important;\n}\n\n.grigo-landing .skip {\n  position: absolute;\n  left: 12px;\n  top: -64px;\n  z-index: 100;\n  background: var(--brand);\n  color: var(--on-brand);\n  padding: 10px 18px;\n  border-radius: 999px;\n  font-weight: 650;\n}\n\n.grigo-landing .skip:focus {\n  top: 12px;\n}\n\n.grigo-landing h1,\n.grigo-landing h2,\n.grigo-landing h3 {\n  color: var(--ink);\n  text-wrap: balance;\n}\n\n.grigo-landing h1 {\n  font-size: clamp(2.6rem, 6.3vw, 5.1rem);\n  line-height: 1.02;\n  letter-spacing: -0.038em;\n  font-weight: 790;\n}\n\n.grigo-landing h2 {\n  font-size: clamp(2.1rem, 4.4vw, 3.5rem);\n  line-height: 1.05;\n  letter-spacing: -0.034em;\n  font-weight: 770;\n}\n\n.grigo-landing h3 {\n  font-size: 1.2rem;\n  line-height: 1.3;\n  letter-spacing: -0.015em;\n  font-weight: 700;\n}\n\n.grigo-landing p {\n  text-wrap: pretty;\n}\n\n.grigo-landing .lead {\n  font-size: clamp(1.1rem, 1.5vw, 1.3rem);\n  line-height: 1.55;\n  color: var(--ink-2);\n  max-width: 60ch;\n  font-weight: 450;\n}\n\n.grigo-landing .muted {\n  color: var(--ink-3);\n}\n\n.grigo-landing .small {\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.grigo-landing kbd {\n  font-family: var(--mono);\n  font-size: 0.82em;\n  font-weight: 500;\n  padding: 2px 8px;\n  border: 1px solid var(--line-strong);\n  border-bottom-width: 2px;\n  border-radius: var(--r-s);\n  background: var(--surface);\n  color: var(--ink);\n}\n\n.grigo-landing .ic {\n  width: 20px;\n  height: 20px;\n  flex: none;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.grigo-landing .ic-sm {\n  width: 16px;\n  height: 16px;\n}\n\n.grigo-landing .ic-lg {\n  width: 24px;\n  height: 24px;\n}\n\n.grigo-landing .ico {\n  width: 46px;\n  height: 46px;\n  border-radius: 14px;\n  display: grid;\n  place-items: center;\n  flex: none;\n  color: var(--ic, var(--blue-ink));\n  background: var(--icbg, var(--blue-soft));\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);\n}\n\n.grigo-landing .ico--sage {\n  --ic: var(--sage-ink);\n  --icbg: var(--sage-soft);\n}\n\n.grigo-landing .ico--blue {\n  --ic: var(--blue-ink);\n  --icbg: var(--blue-soft);\n}\n\n.grigo-landing .ico--amber {\n  --ic: var(--amber-ink);\n  --icbg: var(--amber-soft);\n}\n\n.grigo-landing .ico--sm {\n  width: 38px;\n  height: 38px;\n  border-radius: 12px;\n}\n\n.grigo-landing .pm {\n  width: 14px;\n  height: 14px;\n  flex: none;\n}\n\n.grigo-landing .pm-openai {\n  color: var(--blue-gfx);\n}\n\n.grigo-landing .pm-anthropic {\n  color: var(--tan-gfx);\n}\n\n.grigo-landing .pm-google {\n  color: var(--amber-gfx);\n}\n\n.grigo-landing .wrap {\n  width: 100%;\n  max-width: 1240px;\n  margin-inline: auto;\n  padding-inline: clamp(20px, 4vw, 40px);\n}\n\n.grigo-landing .section {\n  position: relative;\n  padding-block: clamp(52px, 7vw, 96px);\n  scroll-margin-top: 20px;\n}\n\n.grigo-landing .center-head {\n  display: grid;\n  justify-items: center;\n  text-align: center;\n  gap: 20px;\n  margin: 0 auto clamp(28px, 4vw, 48px);\n  max-width: 860px;\n}\n\n.grigo-landing .center-head .lead {\n  margin-inline: auto;\n}\n\n.grigo-landing .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 52px;\n  padding: 0 28px;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  font-weight: 680;\n  font-size: 1.02rem;\n  line-height: 1.2;\n  text-decoration: none;\n  white-space: nowrap;\n  transition:\n    transform 160ms ease-out,\n    box-shadow 160ms ease-out,\n    background-color 160ms ease-out;\n}\n\n.grigo-landing .btn:hover {\n  text-decoration: none;\n  transform: translateY(-1px);\n}\n\n.grigo-landing .btn-primary {\n  background: var(--brand-grad);\n  color: var(--on-brand);\n  box-shadow:\n    var(--btn-glow),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n}\n\n.grigo-landing .btn-primary:hover {\n  color: var(--on-brand);\n  box-shadow:\n    0 14px 30px -10px rgba(43, 74, 120, 0.85),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n}\n\n.grigo-landing .btn-secondary {\n  background: var(--glass);\n  color: var(--ink);\n  border-color: var(--line-strong);\n  backdrop-filter: blur(10px);\n}\n\n.grigo-landing .btn-secondary:hover {\n  background: var(--surface);\n  color: var(--ink);\n}\n\n.grigo-landing .btn-sm {\n  min-height: 40px;\n  padding: 0 18px;\n  font-size: 0.93rem;\n}\n\n.grigo-landing .btn[aria-disabled='true'] {\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.grigo-landing .btn-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  justify-content: center;\n}\n\n.grigo-landing .chip {\n  min-height: 36px;\n  padding: 0 16px;\n  border-radius: 999px;\n  background: var(--surface);\n  border: 1px solid var(--line-strong);\n  font-size: 0.9rem;\n  font-weight: 620;\n  color: var(--ink);\n  transition:\n    background-color 140ms ease-out,\n    transform 140ms ease-out;\n}\n\n.grigo-landing .chip:hover {\n  background: var(--surface-2);\n  transform: translateY(-1px);\n}\n\n.grigo-landing .tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 11px;\n  border-radius: 999px;\n  border: 1px solid var(--line-strong);\n  font-size: 0.8rem;\n  font-weight: 650;\n  color: var(--ink-2);\n  background: var(--surface);\n  white-space: nowrap;\n}\n\n.grigo-landing .site-header {\n  position: fixed;\n  inset: 0 0 auto 0;\n  z-index: 60;\n  padding: 14px clamp(12px, 3vw, 32px) 0;\n  pointer-events: none;\n}\n\n.grigo-landing .nav-pill {\n  pointer-events: auto;\n  position: relative;\n  max-width: 1160px;\n  margin-inline: auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 8px 8px 20px;\n  border-radius: 999px;\n  background: var(--nav-bg);\n  border: 1px solid var(--glass-line);\n  backdrop-filter: blur(20px) saturate(1.5);\n  box-shadow:\n    var(--sh-1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.5);\n  transition: box-shadow 200ms ease-out;\n}\n\n.grigo-landing .site-header.scrolled .nav-pill {\n  box-shadow:\n    var(--sh-2),\n    inset 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n\n.grigo-landing .brand {\n  display: inline-flex;\n  align-items: center;\n  flex: none;\n  text-decoration: none;\n  color: var(--ink);\n}\n\n.grigo-landing .brand img {\n  height: 40px;\n  width: auto;\n  max-width: none;\n}\n\n.grigo-landing .nav {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 2px;\n  margin: 0 auto;\n  padding: 0;\n  margin-bottom: 0;\n}\n\n.grigo-landing .nav a {\n  padding: 8px 14px;\n  border-radius: 999px;\n  text-decoration: none;\n  color: var(--ink-2);\n  font-weight: 620;\n  font-size: 0.95rem;\n  white-space: nowrap;\n  transition:\n    background-color 140ms ease-out,\n    color 140ms ease-out;\n}\n\n.grigo-landing .nav a:hover {\n  background: var(--surface-3);\n  color: var(--ink);\n}\n\n.grigo-landing .nav .nav-cta {\n  display: none;\n}\n\n.grigo-landing .header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: none;\n}\n\n.grigo-landing .icon-btn {\n  min-width: 42px;\n  height: 42px;\n  padding: 0 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: transparent;\n  border: 1px solid var(--line-strong);\n  border-radius: 999px;\n  font-weight: 620;\n  font-size: 0.9rem;\n}\n\n.grigo-landing .icon-btn:hover {\n  background: var(--surface-3);\n}\n\n.grigo-landing .menu-btn {\n  display: none;\n}\n\n.grigo-landing .window-wrap {\n  position: relative;\n  width: 100%;\n  max-width: 1200px;\n  margin: clamp(28px, 3.5vw, 44px) auto 0;\n  text-align: left;\n  padding: 1px;\n  border-radius: 29px;\n  box-shadow: var(--sh-window);\n  background: linear-gradient(\n    135deg,\n    rgba(124, 151, 144, 0.9),\n    rgba(98, 126, 163, 0.9) 50%,\n    rgba(227, 163, 62, 0.9)\n  );\n  scroll-margin-top: 96px;\n}\n\n.grigo-landing .window {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 356px;\n  min-height: 0;\n  border-radius: 28px;\n  background: var(--surface);\n  overflow: hidden;\n}\n\n.grigo-landing .win-main {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.grigo-landing .win-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 22px;\n  border-bottom: 1px solid var(--line);\n}\n\n.grigo-landing .win-title {\n  font-weight: 700;\n  font-size: 1.02rem;\n  letter-spacing: -0.01em;\n}\n\n.grigo-landing .chip-static {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 30px;\n  padding: 0 12px;\n  border-radius: 999px;\n  background: var(--surface-2);\n  border: 1px solid var(--line);\n  font-size: 0.8rem;\n  font-weight: 650;\n  color: var(--ink-2);\n  white-space: nowrap;\n}\n\n.grigo-landing .chip-static + .chip-static {\n  margin-left: 6px;\n}\n\n.grigo-landing .chip-static .sep {\n  width: 1px;\n  height: 12px;\n  background: var(--line-strong);\n  opacity: 0.5;\n}\n\n.grigo-landing .composer {\n  margin: 20px 20px 0;\n  border: 1px solid var(--line-strong);\n  border-radius: 22px;\n  background: var(--surface);\n  box-shadow: var(--sh-1);\n}\n\n.grigo-landing .composer:focus-within {\n  outline: 2px solid var(--focus);\n  outline-offset: 2px;\n}\n\n.grigo-landing .field {\n  position: relative;\n}\n\n.grigo-landing .field .hl,\n.grigo-landing .field textarea {\n  display: block;\n  width: 100%;\n  height: 100px;\n  margin: 0;\n  padding: 16px 18px 6px;\n  font: inherit;\n  font-size: 1rem;\n  line-height: 1.55;\n  letter-spacing: 0;\n  font-weight: 450;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n  border: 0;\n  border-radius: 22px 22px 0 0;\n  scrollbar-gutter: stable;\n}\n\n.grigo-landing .field .hl {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  color: transparent;\n  pointer-events: none;\n}\n\n.grigo-landing .field textarea {\n  position: relative;\n  resize: none;\n  overflow-y: auto;\n  background: transparent;\n  color: var(--ink);\n  outline: none;\n  caret-color: var(--ink);\n}\n\n.grigo-landing .hl mark {\n  color: transparent;\n  border-radius: 3px;\n  padding: 1px 0;\n}\n\n.grigo-landing .t1 {\n  background: var(--warn-soft);\n  text-decoration: underline dotted 2px var(--warn);\n  text-underline-offset: 4px;\n}\n\n.grigo-landing .t2 {\n  background: var(--blue-soft);\n  text-decoration: underline dashed 2px var(--blue-ink);\n  text-underline-offset: 4px;\n}\n\n.grigo-landing .t3 {\n  background: var(--err-soft);\n  text-decoration: underline solid 3px var(--err);\n  text-underline-offset: 4px;\n}\n\n.grigo-landing .composer-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px 10px 14px;\n  color: var(--ink-3);\n}\n\n.grigo-landing .composer-bar .grow {\n  flex: 1;\n}\n\n.grigo-landing .send {\n  flex: none;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  border: 0;\n  display: grid;\n  place-items: center;\n  background: var(--brand-grad);\n  color: var(--on-brand);\n  box-shadow: var(--btn-glow);\n  transition: transform 140ms ease-out;\n}\n\n.grigo-landing .send:hover {\n  transform: translateY(-1px);\n}\n\n.grigo-landing .send[aria-disabled='true'] {\n  opacity: 0.45;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.grigo-landing .pii-bar {\n  margin: 12px 20px 20px;\n  display: grid;\n  gap: 4px;\n}\n\n.grigo-landing .banner {\n  border-radius: 14px;\n  padding: 12px 16px;\n  font-size: 0.92rem;\n  line-height: 1.5;\n  color: var(--ink-2);\n  background: var(--surface-2);\n  border: 1px solid var(--line);\n  border-left: 4px solid var(--line-strong);\n}\n\n.grigo-landing .banner strong {\n  color: var(--ink);\n}\n\n.grigo-landing .banner--warn {\n  border-left-color: var(--warn);\n  background: var(--warn-soft);\n}\n\n.grigo-landing .banner--mask {\n  border-left-color: var(--blue-ink);\n  background: var(--blue-soft);\n}\n\n.grigo-landing .banner--block {\n  border-left-color: var(--err);\n  background: var(--err-soft);\n}\n\n.grigo-landing .banner--ok {\n  border-left-color: var(--ok);\n  background: var(--ok-soft);\n}\n\n.grigo-landing .demo-msg {\n  font-size: 0.88rem;\n  color: var(--ink-2);\n  min-height: 1.3em;\n  padding-left: 4px;\n}\n\n.grigo-landing .panel {\n  background: var(--surface-2);\n  border-left: 1px solid var(--line);\n  padding: 20px 20px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-width: 0;\n}\n\n.grigo-landing .panel-title {\n  font-size: 1.15rem;\n  letter-spacing: -0.02em;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.grigo-landing .demo-presets {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.grigo-landing .demo-presets .chip {\n  min-height: 32px;\n  padding: 0 13px;\n  font-size: 0.84rem;\n}\n\n.grigo-landing .findings {\n  display: grid;\n  gap: 8px;\n}\n\n.grigo-landing .findings li {\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  display: grid;\n  gap: 4px;\n  font-size: 0.9rem;\n}\n\n.grigo-landing .f-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.grigo-landing .tier {\n  display: inline-flex;\n  gap: 6px;\n  align-items: baseline;\n  font-weight: 700;\n  padding: 1px 9px;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  text-decoration: none;\n}\n\n.grigo-landing .tier span {\n  font-weight: 500;\n}\n\n.grigo-landing .tier.t1 {\n  color: var(--warn);\n  background: transparent;\n  text-decoration: none;\n}\n\n.grigo-landing .tier.t2 {\n  color: var(--blue-ink);\n  background: transparent;\n  text-decoration: none;\n}\n\n.grigo-landing .tier.t3 {\n  color: var(--err);\n  background: transparent;\n  text-decoration: none;\n}\n\n.grigo-landing .f-res {\n  font-weight: 700;\n  font-size: 0.82rem;\n  color: var(--ink);\n}\n\n.grigo-landing .f-type {\n  font-weight: 620;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.grigo-landing .f-type code {\n  font-family: var(--mono);\n  font-size: 0.82em;\n  font-weight: 500;\n  color: var(--ink-3);\n}\n\n.grigo-landing .seen {\n  border: 1px dashed var(--line-strong);\n  border-radius: 14px;\n  padding: 12px 14px;\n  display: grid;\n  gap: 6px;\n  background: var(--surface);\n  margin: 0 20px 20px;\n}\n\n.grigo-landing .seen h3 {\n  font-size: 0.92rem;\n}\n\n.grigo-landing .seen-text {\n  font-size: 0.93rem;\n  line-height: 1.55;\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n  color: var(--ink);\n}\n\n.grigo-landing .token {\n  font-family: var(--mono);\n  font-size: 0.82em;\n  padding: 1px 7px;\n  border: 1px dashed var(--blue-ink);\n  border-radius: 6px;\n  color: var(--blue-ink);\n  background: var(--blue-soft);\n  white-space: nowrap;\n}\n\n.grigo-landing .demo-foot {\n  font-size: 0.8rem;\n  color: var(--ink-3);\n  margin-top: auto;\n}\n\n.grigo-landing .cta {\n  position: relative;\n  isolation: isolate;\n  overflow: hidden;\n  text-align: center;\n  display: grid;\n  justify-items: center;\n  gap: 24px;\n  padding: clamp(48px, 8vw, 104px) clamp(24px, 5vw, 64px);\n  border-radius: 36px;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  box-shadow: var(--sh-2);\n}\n\n.grigo-landing .cta::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  opacity: var(--aurora-o);\n  background:\n    radial-gradient(45% 70% at 12% 20%, var(--aurora-a), transparent 70%),\n    radial-gradient(45% 70% at 90% 15%, var(--aurora-b), transparent 70%),\n    radial-gradient(40% 60% at 55% 110%, var(--aurora-c), transparent 70%);\n}\n\n.grigo-landing .cta h2 {\n  max-width: 16ch;\n}\n\n.grigo-landing .hero {\n  position: relative;\n  isolation: isolate;\n  padding: clamp(104px, 9vw, 124px) 0 clamp(36px, 4vw, 56px);\n  overflow: hidden;\n}\n\n.grigo-landing .aurora {\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.grigo-landing .aurora i {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(90px);\n  opacity: var(--aurora-o);\n}\n\n.grigo-landing .aurora .a1 {\n  width: 640px;\n  height: 640px;\n  left: -10%;\n  top: -18%;\n  background: var(--aurora-a);\n}\n\n.grigo-landing .aurora .a2 {\n  width: 760px;\n  height: 760px;\n  right: -12%;\n  top: -22%;\n  background: var(--aurora-b);\n}\n\n.grigo-landing .aurora .a3 {\n  width: 560px;\n  height: 560px;\n  left: 30%;\n  top: 22%;\n  background: var(--aurora-c);\n  opacity: calc(var(--aurora-o) * 0.6);\n}\n\n.grigo-landing .hero::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  pointer-events: none;\n  background-image: repeating-linear-gradient(90deg, var(--line) 0 1px, transparent 1px 88px);\n  background-position: 20px 0;\n  -webkit-mask-image: radial-gradient(ellipse 70% 60% at 50% 20%, #000 0%, transparent 75%);\n  mask-image: radial-gradient(ellipse 70% 60% at 50% 20%, #000 0%, transparent 75%);\n}\n\n.grigo-landing .hero-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.05fr);\n  gap: clamp(28px, 4.5vw, 64px);\n  align-items: center;\n}\n\n.grigo-landing .hero-copy {\n  display: grid;\n  gap: 22px;\n  justify-items: start;\n  text-align: left;\n}\n\n.grigo-landing .hero h1 {\n  font-size: clamp(2.3rem, 4.4vw, 3.6rem);\n  line-height: 1.04;\n  max-width: 12em;\n}\n\n.grigo-landing .hero .lead {\n  max-width: 46ch;\n  margin: 0;\n}\n\n.grigo-landing .hero-copy .btn-row {\n  justify-content: flex-start;\n}\n\n.grigo-landing .stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 36px;\n  padding-top: 20px;\n  border-top: 1px solid var(--line-strong);\n  width: 100%;\n  max-width: 560px;\n}\n\n.grigo-landing .stats div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.grigo-landing .stats dd {\n  order: 1;\n  font-size: 2rem;\n  font-weight: 780;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n  font-variant-numeric: tabular-nums;\n}\n\n.grigo-landing .stats dt {\n  order: 2;\n  font-size: 0.86rem;\n  color: var(--ink-2);\n  font-weight: 600;\n}\n\n.grigo-landing .hub {\n  --blue-gfx: #7fa2db;\n  --tan-gfx: #c9a56a;\n  --amber-gfx: #e3a63f;\n  position: relative;\n  isolation: isolate;\n  border-radius: var(--r-xl);\n  padding: 22px 22px 16px;\n  color: #eef2f8;\n  text-align: left;\n  overflow: hidden;\n  background:\n    radial-gradient(55% 48% at 50% 46%, rgba(143, 176, 230, 0.2), transparent 72%), #0c1630;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: var(--sh-window);\n}\n\n.grigo-landing .hub::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  pointer-events: none;\n  background-image: radial-gradient(rgba(255, 255, 255, 0.09) 1px, transparent 1px);\n  background-size: 18px 18px;\n  -webkit-mask-image: radial-gradient(ellipse 85% 75% at 50% 46%, #000, transparent 88%);\n  mask-image: radial-gradient(ellipse 85% 75% at 50% 46%, #000, transparent 88%);\n}\n\n.grigo-landing .hub-top {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 8px;\n  font-size: 0.85rem;\n  font-weight: 650;\n  color: #c3cddf;\n}\n\n.grigo-landing .hub-top .live {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.grigo-landing .hub-top .live::before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #8fd1ac;\n  box-shadow: 0 0 10px #8fd1ac;\n}\n\n.grigo-landing .hub-stage {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(20px, 0.45fr) 100px minmax(20px, 0.45fr) minmax(\n      0,\n      1fr\n    );\n  height: 300px;\n}\n\n.grigo-landing .hub-col {\n  display: grid;\n  grid-template-rows: repeat(3, 1fr);\n  align-items: center;\n}\n\n.grigo-landing .hn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 56px;\n  padding: 8px 12px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  color: #fff;\n  font-weight: 650;\n  font-size: 0.9rem;\n  line-height: 1.2;\n}\n\n.grigo-landing .hub-out {\n  grid-template-rows: repeat(4, 1fr);\n}\n\n.grigo-landing .hn.more {\n  border-style: dashed;\n  color: #c3cddf;\n}\n\n.grigo-landing .hn small {\n  display: block;\n  color: #9facc4;\n  font-weight: 500;\n  font-size: 0.76rem;\n}\n\n.grigo-landing .hn .ic {\n  color: #9db9e6;\n}\n\n.grigo-landing .hub-lines {\n  display: block;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n}\n\n.grigo-landing .hub-lines path {\n  fill: none;\n  vector-effect: non-scaling-stroke;\n}\n\n.grigo-landing .hub-lines .base {\n  stroke: rgba(255, 255, 255, 0.16);\n  stroke-width: 1.5;\n}\n\n.grigo-landing .hub-lines .flow {\n  stroke: #8fb0e6;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-dasharray: 3 12;\n}\n\n.grigo-landing .hub-core {\n  position: relative;\n  align-self: center;\n  justify-self: center;\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: linear-gradient(180deg, #24427a, #14264b);\n  border: 1px solid rgba(143, 176, 230, 0.65);\n  box-shadow:\n    0 0 40px rgba(143, 176, 230, 0.35),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.grigo-landing .hub-core img {\n  height: 34px;\n  width: auto;\n  max-width: 78px;\n}\n\n.grigo-landing .ring {\n  position: absolute;\n  inset: -4px;\n  border-radius: 50%;\n  border: 1px solid rgba(143, 176, 230, 0.55);\n  pointer-events: none;\n}\n\n.grigo-landing .hub-feats {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.grigo-landing .hub-feats .tag {\n  background: rgba(255, 255, 255, 0.07);\n  color: #eef2f8;\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.grigo-landing .feat-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.grigo-landing .feat {\n  position: relative;\n  display: grid;\n  gap: 10px;\n  align-content: start;\n  padding: 26px 24px 24px;\n  border-radius: var(--r-l);\n  background: var(--surface);\n  border: 1px solid var(--line);\n  box-shadow: var(--sh-1);\n  transition:\n    transform 200ms ease-out,\n    box-shadow 200ms ease-out,\n    border-color 200ms ease-out;\n}\n\n.grigo-landing .feat:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--sh-2);\n  border-color: var(--blue-gfx);\n}\n\n.grigo-landing .feat .ico {\n  margin-bottom: 4px;\n}\n\n.grigo-landing .feat h3 {\n  font-size: 1.15rem;\n}\n\n.grigo-landing .feat p {\n  color: var(--ink-2);\n  font-size: 0.97rem;\n  line-height: 1.5;\n}\n\n.grigo-landing .feat .spec-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.grigo-landing .cost-grid,\n.grigo-landing .story-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.05fr);\n  gap: 24px;\n  align-items: stretch;\n}\n\n.grigo-landing .levers {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.grigo-landing .levers .feat {\n  padding: 20px 18px 18px;\n}\n\n.grigo-landing .levers .feat h3 {\n  font-size: 1.05rem;\n}\n\n.grigo-landing .levers .feat p {\n  font-size: 0.93rem;\n}\n\n.grigo-landing .card {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-xl);\n  box-shadow: var(--sh-1);\n  padding: 24px 26px;\n  display: grid;\n  gap: 16px;\n  align-content: start;\n  min-width: 0;\n  color: var(--ink);\n}\n\n.grigo-landing .card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.grigo-landing .card-head h3 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 1.1rem;\n}\n\n.grigo-landing .kpis {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.grigo-landing .kpi {\n  padding: 12px 14px;\n  border-radius: 14px;\n  background: var(--surface-2);\n  border: 1px solid var(--line);\n  display: grid;\n  gap: 2px;\n}\n\n.grigo-landing .kpi b {\n  font-size: 1.45rem;\n  letter-spacing: -0.03em;\n  line-height: 1.15;\n  font-variant-numeric: tabular-nums;\n  color: var(--ink);\n}\n\n.grigo-landing .kpi span {\n  font-size: 0.8rem;\n  color: var(--ink-3);\n  font-weight: 620;\n}\n\n.grigo-landing .brow {\n  display: grid;\n  grid-template-columns: 108px minmax(0, 1fr) auto;\n  gap: 14px;\n  align-items: center;\n  font-size: 0.93rem;\n}\n\n.grigo-landing .brow > span:first-child {\n  font-weight: 650;\n  color: var(--ink);\n}\n\n.grigo-landing .brow .amt {\n  font-variant-numeric: tabular-nums;\n  color: var(--ink-2);\n  font-weight: 600;\n  white-space: nowrap;\n  text-align: right;\n  min-width: 108px;\n}\n\n.grigo-landing .meter {\n  height: 10px;\n  border-radius: 999px;\n  background: var(--surface-3);\n  overflow: hidden;\n}\n\n.grigo-landing .meter > i {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: var(--sage-gfx);\n}\n\n.grigo-landing .meter > i.warn {\n  background: var(--amber-gfx);\n}\n\n.grigo-landing .meter > i.over {\n  background: var(--err);\n}\n\n.grigo-landing .story-list {\n  display: grid;\n  gap: 14px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.grigo-landing .story-list li {\n  display: grid;\n  gap: 2px;\n}\n\n.grigo-landing .story-list strong {\n  font-size: 0.98rem;\n}\n\n.grigo-landing .story-list span {\n  color: var(--ink-2);\n  font-size: 0.93rem;\n  line-height: 1.45;\n}\n\n.grigo-landing .flow-steps {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.grigo-landing .flow-step {\n  display: grid;\n  gap: 8px;\n  align-content: start;\n  padding: 22px 20px;\n  border-radius: var(--r-l);\n  background: var(--surface);\n  border: 1px solid var(--line);\n  box-shadow: var(--sh-1);\n}\n\n.grigo-landing .flow-step b {\n  font-size: 0.78rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--blue-ink);\n}\n\n.grigo-landing .flow-step p {\n  color: var(--ink-2);\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.grigo-landing .specs-card {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-xl);\n  box-shadow: var(--sh-1);\n  padding: 6px 32px;\n}\n\n.grigo-landing .specs {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 56px;\n}\n\n.grigo-landing .spec {\n  display: grid;\n  grid-template-columns: 132px minmax(0, 1fr);\n  gap: 16px;\n  align-items: baseline;\n  padding: 16px 0;\n  border-bottom: 1px solid var(--line);\n}\n\n.grigo-landing .spec:nth-last-child(-n + 2) {\n  border-bottom: 0;\n}\n\n.grigo-landing .spec dt {\n  color: var(--ink-3);\n  font-weight: 650;\n  font-size: 0.9rem;\n}\n\n.grigo-landing .spec dd {\n  font-weight: 600;\n  color: var(--ink);\n  font-size: 0.97rem;\n  line-height: 1.45;\n}\n\n.grigo-landing .site-footer {\n  padding: 36px 0 30px;\n  border-top: 1px solid var(--line);\n}\n\n.grigo-landing .footer-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px 28px;\n}\n\n.grigo-landing .footer-id {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex: none;\n  min-width: 0;\n}\n\n.grigo-landing .footer-id .brand {\n  margin-right: 0;\n}\n\n.grigo-landing .site-footer nav {\n  flex: 1 1 280px;\n  min-width: 0;\n}\n\n.grigo-landing .site-footer ul {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px 24px;\n}\n\n.grigo-landing .site-footer li a {\n  color: var(--ink-2);\n  text-decoration: none;\n  font-weight: 560;\n  font-size: 0.95rem;\n}\n\n.grigo-landing .site-footer li a:hover {\n  color: var(--ink);\n  text-decoration: underline;\n}\n\n.grigo-landing .footer-note {\n  margin: 0;\n  color: var(--ink-3);\n  font-size: 0.86rem;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.grigo-landing .demo-dialog {\n  border: 0;\n  padding: 0;\n  width: min(520px, calc(100vw - 24px));\n  min-width: min(520px, calc(100vw - 24px));\n  max-height: calc(100dvh - 24px);\n  overflow: auto;\n  border-radius: var(--r-xl);\n  background: var(--surface);\n  color: var(--ink);\n  box-shadow: var(--sh-window);\n}\n\n.grigo-landing .demo-dialog[open] {\n  display: block;\n}\n\n.grigo-landing .demo-dialog::backdrop {\n  background: rgba(8, 15, 30, 0.58);\n  backdrop-filter: blur(4px);\n}\n\n.grigo-landing .modal-box {\n  position: relative;\n  display: grid;\n  gap: 14px;\n  padding: 28px 28px 24px;\n}\n\n.grigo-landing .demo-dialog h2 {\n  font-size: 1.7rem;\n  line-height: 1.1;\n  letter-spacing: -0.03em;\n  padding-right: 44px;\n}\n\n.grigo-landing .modal-x {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 40px;\n  height: 40px;\n  display: grid;\n  place-items: center;\n  border: 1px solid var(--line-strong);\n  border-radius: 50%;\n  background: transparent;\n}\n\n.grigo-landing .modal-x:hover {\n  background: var(--surface-3);\n}\n\n.grigo-landing .demo-form {\n  display: grid;\n  gap: 14px;\n  margin-top: 4px;\n}\n\n.grigo-landing .fg {\n  display: grid;\n  gap: 6px;\n}\n\n.grigo-landing .fg label {\n  display: grid;\n  gap: 6px;\n  font-weight: 650;\n  font-size: 0.92rem;\n}\n\n.grigo-landing .fg .opt {\n  color: var(--ink-3);\n  font-weight: 500;\n}\n\n.grigo-landing .fg input,\n.grigo-landing .fg select,\n.grigo-landing .fg textarea {\n  width: 100%;\n  font: inherit;\n  font-size: 1rem;\n  color: var(--ink);\n  background: var(--surface);\n  border: 1px solid var(--line-strong);\n  border-radius: 12px;\n  padding: 11px 14px;\n  min-height: 46px;\n}\n\n.grigo-landing .fg textarea {\n  resize: vertical;\n  min-height: 84px;\n}\n\n.grigo-landing .fg [aria-invalid='true'] {\n  border-color: var(--err);\n  box-shadow: 0 0 0 1px var(--err);\n}\n\n.grigo-landing .err-msg {\n  color: var(--err);\n  font-size: 0.86rem;\n  font-weight: 600;\n}\n\n.grigo-landing .bd-alert {\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: var(--err-soft);\n  border-left: 4px solid var(--err);\n  font-size: 0.93rem;\n}\n\n.grigo-landing .bd-hp {\n  position: absolute;\n  left: -9999px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n\n.grigo-landing .demo-form .btn {\n  width: 100%;\n}\n\n.grigo-landing .demo-form .btn[disabled] {\n  opacity: 0.6;\n  cursor: progress;\n}\n\n.grigo-landing .bd-done {\n  display: grid;\n  align-content: center;\n  min-height: 168px;\n  outline: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .grigo-landing .aurora .a1 {\n    animation: gl-drift1 26s ease-in-out infinite alternate;\n  }\n\n  .grigo-landing .aurora .a2 {\n    animation: gl-drift2 32s ease-in-out infinite alternate;\n  }\n\n  .grigo-landing .aurora .a3 {\n    animation: gl-drift1 38s ease-in-out infinite alternate-reverse;\n  }\n\n  .grigo-landing .rise {\n    animation: gl-rise 900ms cubic-bezier(0.2, 0.7, 0.2, 1) both;\n    animation-delay: calc(var(--d, 0) * 90ms);\n  }\n\n  .grigo-landing .hub.anim .flow {\n    animation: gl-dash 1.4s linear infinite;\n  }\n\n  .grigo-landing .hub.anim .ring {\n    animation: gl-ping 3.2s ease-out infinite;\n  }\n\n  .grigo-landing .hub.anim .ring.r2 {\n    animation-delay: 1.6s;\n  }\n\n  .grigo-landing .hub.anim .hub-in .hn {\n    animation: gl-act 9s ease-in-out infinite;\n  }\n\n  .grigo-landing .hub.anim .hub-in .hn:nth-child(2) {\n    animation-delay: 3s;\n  }\n\n  .grigo-landing .hub.anim .hub-in .hn:nth-child(3) {\n    animation-delay: 6s;\n  }\n\n  .grigo-landing .hub.anim .hub-out .hn {\n    animation: gl-act 9s ease-in-out infinite;\n    animation-delay: 1.4s;\n  }\n\n  .grigo-landing .hub.anim .hub-out .hn:nth-child(2) {\n    animation-delay: 3.65s;\n  }\n\n  .grigo-landing .hub.anim .hub-out .hn:nth-child(3) {\n    animation-delay: 5.9s;\n  }\n\n  .grigo-landing .hub.anim .hub-out .hn:nth-child(4) {\n    animation-delay: 8.15s;\n  }\n\n  .grigo-landing .reveal {\n    opacity: 0;\n    transform: translateY(18px);\n    transition:\n      opacity 600ms ease-out,\n      transform 600ms ease-out;\n  }\n\n  .grigo-landing .reveal.in {\n    opacity: 1;\n    transform: none;\n  }\n\n  .grigo-landing .demo-dialog[open] {\n    animation: gl-pop 220ms ease-out;\n  }\n\n  .grigo-landing .demo-dialog[open]::backdrop {\n    animation: gl-fadein 220ms ease-out;\n  }\n}\n\n@keyframes gl-drift1 {\n  to {\n    transform: translate3d(90px, 50px, 0) scale(1.08);\n  }\n}\n\n@keyframes gl-drift2 {\n  to {\n    transform: translate3d(-110px, 70px, 0) scale(1.1);\n  }\n}\n\n@keyframes gl-rise {\n  from {\n    opacity: 0;\n    transform: translateY(18px);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@keyframes gl-dash {\n  to {\n    stroke-dashoffset: -30;\n  }\n}\n\n@keyframes gl-ping {\n  0% {\n    transform: scale(0.85);\n    opacity: 0.8;\n  }\n\n  100% {\n    transform: scale(1.55);\n    opacity: 0;\n  }\n}\n\n@keyframes gl-act {\n  0%,\n  30% {\n    border-color: #8fb0e6;\n    background: rgba(143, 176, 230, 0.17);\n    box-shadow:\n      0 0 0 3px rgba(143, 176, 230, 0.16),\n      0 0 22px rgba(143, 176, 230, 0.32);\n  }\n\n  38%,\n  100% {\n    border-color: rgba(255, 255, 255, 0.16);\n    background: rgba(255, 255, 255, 0.06);\n    box-shadow: 0 0 0 0 rgba(143, 176, 230, 0);\n  }\n}\n\n@keyframes gl-pop {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.98);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@keyframes gl-fadein {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@media (max-width: 1200px) {\n  .grigo-landing .window {\n    grid-template-columns: minmax(0, 1fr) 340px;\n  }\n\n  .grigo-landing .nav a {\n    padding-inline: 10px;\n  }\n\n  .grigo-landing .header-actions .btn-sm {\n    padding-inline: 14px;\n  }\n}\n\n@media (max-width: 1000px) {\n  .grigo-landing .nav {\n    display: none;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: calc(100% + 10px);\n    flex-direction: column;\n    background: var(--glass);\n    border: 1px solid var(--glass-line);\n    border-radius: 28px;\n    padding: 10px;\n    backdrop-filter: blur(20px);\n    box-shadow: var(--sh-2);\n    margin: 0;\n  }\n\n  .grigo-landing .nav.open {\n    display: flex;\n  }\n\n  .grigo-landing .nav a {\n    padding: 14px 16px;\n  }\n\n  .grigo-landing .nav .nav-cta {\n    display: block;\n    background: var(--brand-grad);\n    color: var(--on-brand);\n    text-align: center;\n    margin-top: 6px;\n  }\n\n  .grigo-landing .nav .nav-cta:hover {\n    background: var(--brand-grad);\n    color: var(--on-brand);\n  }\n\n  .grigo-landing .menu-btn {\n    display: inline-flex;\n  }\n\n  .grigo-landing .header-actions .btn {\n    display: none;\n  }\n\n  .grigo-landing .brand {\n    margin-right: auto;\n  }\n\n  .grigo-landing .hero-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .grigo-landing .hero-copy {\n    justify-items: center;\n    text-align: center;\n  }\n\n  .grigo-landing .hero h1 {\n    max-width: 14em;\n  }\n\n  .grigo-landing .hero-copy .btn-row,\n  .grigo-landing .stats {\n    justify-content: center;\n  }\n\n  .grigo-landing .window {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .grigo-landing .panel {\n    border-left: 0;\n    border-top: 1px solid var(--line);\n  }\n\n  .grigo-landing .feat-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .grigo-landing .cost-grid,\n  .grigo-landing .story-grid,\n  .grigo-landing .flow-steps {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .grigo-landing .specs {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .grigo-landing .spec:nth-last-child(2) {\n    border-bottom: 1px solid var(--line);\n  }\n}\n\n@media (max-width: 680px) {\n  .grigo-landing .hero {\n    padding-top: 100px;\n  }\n\n  .grigo-landing .win-head {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .grigo-landing .field .hl,\n  .grigo-landing .field textarea {\n    height: 156px;\n  }\n\n  .grigo-landing .feat-grid,\n  .grigo-landing .levers,\n  .grigo-landing .kpis {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .grigo-landing .brow {\n    grid-template-columns: 88px minmax(0, 1fr);\n  }\n\n  .grigo-landing .brow .amt {\n    grid-column: 1 / -1;\n    text-align: left;\n    min-width: 0;\n  }\n\n  .grigo-landing .spec {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 4px;\n  }\n\n  .grigo-landing .specs-card {\n    padding: 4px 20px;\n  }\n\n  .grigo-landing .cta {\n    border-radius: 28px;\n  }\n\n  .grigo-landing .site-footer ul {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 480px) {\n  .grigo-landing .hub {\n    padding: 18px 14px 14px;\n  }\n\n  .grigo-landing .hub-stage {\n    grid-template-columns: minmax(0, 1fr) 16px 76px 16px minmax(0, 1fr);\n    height: 270px;\n  }\n\n  .grigo-landing .hub-core {\n    width: 76px;\n    height: 76px;\n  }\n\n  .grigo-landing .hn small,\n  .grigo-landing .hn .ic {\n    display: none;\n  }\n\n  .grigo-landing .hn {\n    padding: 8px;\n    font-size: 0.82rem;\n    min-height: 48px;\n  }\n\n  .grigo-landing .modal-box {\n    padding: 24px 20px 20px;\n  }\n\n  .grigo-landing .demo-dialog h2 {\n    font-size: 1.45rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .grigo-landing,\n  .grigo-landing *,\n  .grigo-landing *::before,\n  .grigo-landing *::after {\n    transition: none !important;\n    animation: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
